import React from 'react';
import colorVars from '@farmers-fridge/ui-library/dist/colors.module.css';
import Tag from './Tag';
import styles from './FridgeLocationTags.module.css';
import BalloonsIcon from '../icons/Balloons';
import MobileDeviceIcon from '../icons/MobileDeviceIcon';

/**
 * @param {object} props
 * @param {string} props.className
 * */
function GrandOpeningTag({ className }) {
  return (
    <Tag
      className={`${styles.grandOpeningTag} ${className}`}
      fillColor={colorVars.color_japanese_laurel}
      height={34}
      width={226}
      title="Grand Opening Discount"
    >
      <BalloonsIcon />
      <span>25% Off Grand Opening Discount</span>
    </Tag>
  );
}

/**
 * @param {object} props
 * @param {string} props.className
 * */
function TemporarilyClosedTag({ className }) {
  return (
    <Tag
      className={className}
      fillColor={colorVars.color_silver}
      height={26}
      width={130}
      title="Temporarily Closed"
    >
      <span>Temporarily Closed</span>
    </Tag>
  );
}

/**
 * @param {object} props
 * @param {string} props.className
 * */
function MobileAppDiscountTag({ className }) {
  return (
    <Tag
      className={`${styles.mobileAppDiscountTag} ${className}`}
      fillColor={colorVars.color_japanese_laurel}
      height={34}
      width={172}
      title="Mobile App Discount"
    >
      <MobileDeviceIcon />
      <span>25% Off Mobile Orders</span>
    </Tag>
  );
}

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {FF.Location__LDP} props.location
 */
export default function FridgeLocationTags({ className = '', location }) {
  const {
    featureFlags: {
      isGrandOpening,
      isHolidayMode,
      isLowTierDiscount,
      isMidTierDiscount,
    } = {},
  } = location;

  if (isGrandOpening) {
    return <GrandOpeningTag className={className} />;
  }

  if (isHolidayMode) {
    return <TemporarilyClosedTag className={className} />;
  }

  if (isLowTierDiscount || isMidTierDiscount) {
    return <MobileAppDiscountTag className={className} />;
  }

  return null;
}
